import * as Redux from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toggleExportModal } from "../../actions";
import { DataExport, DataExportProps, DataExportActions } from "./component";
import { currentMerchantName } from "../../selectors";
import { currentPublications } from "../../../AnalyticsMetric/selectors";
import { getUserContext } from "../../../User/selectors";
import { hasFinancePermissions } from "../../../AnalyticsMetric/constants";

const mapStateToProps = (state: any, props: any): DataExportProps => {
  return {
    startDate: state.analytics.start_date,
    endDate: state.analytics.end_date,
    merchantName: currentMerchantName(state),
    gaUserContext: getUserContext(state),
    visible: state.analytics.exportModalVisible,
    hasFinancePermissions: hasFinancePermissions(
      state.user.permissions,
      state.analytics.merchant_id
    ),
    publications: currentPublications(state, props)
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): DataExportActions => {
  return {
    ...Redux.bindActionCreators({ toggleExportModal }, dispatch)
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DataExport)
);



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/DataExport/container.tsx